import React from 'react';
import Styled from './index.styled';

const DEFAULT_THEME = 'default';
const ToyotaButton = ({
  href,
  children = '',
  theme = DEFAULT_THEME,
  size = '',
  onClick = () => {},
  ...props
}) => {
  const DynamicTag = (typeof href !== 'undefined') ? Styled.A : Styled.Button;

  const handleOnClick = (e) => {
    if(typeof onClick === 'function') {
      onClick(e);
    }
  };

  return (
    <DynamicTag
      theme={theme}
      size={size}
      href={href}
      onClick={handleOnClick}
      {...props}
    >
      {children}
    </DynamicTag>
  );
}

export default ToyotaButton;
